import { SvgProps } from '../SvgRendererTypes';

export const SmokeCoSubIcon = ({ fillColor, ...props }: SvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>Smoke CO Sub Icon</title>
      <path
        fill={fillColor}
        d="M8.74,2c.82,6.11-4.74,6.85-4.74,12.53,0,4.12,3.58,7.47,8,7.47s7.64-3.06,7.94-6.92c.04-.17.06-.35.06-.55,0-9.3-11.26-12.53-11.26-12.53ZM12,20.93c-1.67,0-3.07-1.2-3.2-2.73v-.07s-.02-.07-.02-.07c0-.03,0-.05,0-.08,0-2.81,2.07-4.4,3.43-5.15.38,1.97,1.37,2.94,2.12,3.68.62.6.89.89.89,1.47,0,1.62-1.45,2.94-3.22,2.94ZM18.96,14.87v.06s-.02.07-.02.07c-.17,2.16-1.49,4.01-3.37,5.06.4-.6.65-1.31.65-2.07,0-2.39-3.04-2.13-3.17-6.62,0,0-5.28,1.71-5.28,6.62,0,.1.01.2.03.29.05.67.3,1.29.67,1.83-2.07-1.12-3.48-3.2-3.48-5.58s1.04-3.67,2.24-5.21c1.18-1.51,2.49-3.19,2.58-5.87,2.85,1.17,9.18,4.51,9.18,11.08,0,.11-.01.22-.04.34Z"
      />
    </svg>
  );
};
